module.exports = __webpack_public_path__ + "static/media/crow.64f425e5.svg";